import { AuthEnums, MissingDocumentEnums } from "models/enums";
import { TagsProps } from "models/propTypes/commonPropTypes";
import cssExports from "theme/styles/main.module.scss";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import useAPIClientHelper from "./useAPIClientHelper";

function useMissingDocumentService() {
  const { apiClientInstance } = useAPIClientHelper();

  const submit = (id: number, missingDocument: ApiModels.MissingDocumentPut) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).MissingDocumentClient.Put(
      id,
      missingDocument
    );
  };

  const getPdf = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      responseType: "arraybuffer",
    }).MissingDocumentClient.GetPdf(id);
  };

  const getAttachment = (missingDocumentId: number, attachmentId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .MissingDocumentClient.GetAttachmentAsync(missingDocumentId, attachmentId)
      .then((res) => res.data.data ?? "");
  };

  const getAmountType = (amount: number): MissingDocumentEnums.AmountType => {
    return amount > 0 ? MissingDocumentEnums.AmountType.Income : MissingDocumentEnums.AmountType.Expense;
  };

  const getTodoState = (): TagsProps => {
    return {
      tags: [LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.MissingInfoMessage)],
      className: cssExports.yellowTag,
    };
  };
  return {
    submit,
    getPdf,
    getAttachment,
    getAmountType,
    getTodoState,
  };
}

export default useMissingDocumentService;
